import RecruitmentCart from 'module/recruitment/pages/recruitment-cart/view/RecruitmentCart'
import CreateJobAd from 'module/recruitment/pages/recruitment-create-job-ad/view/CreateJobAd'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import RecruitmentTopUpCredit from './pages/recruitment-top-up-credit/view/RecruitmentTopUpCredit'
import RecruitmentDashboard from './pages/recruitment-dashboard/view/RecruitmentDashboard'
import ManageApplicant from './pages/recruitment-manage-applicant/view/ManageApplicant'
import RecruitmentPayment from './pages/recruitment-payment/view/RecruitmentPayment'
import RecruitmentCredit from './pages/recruitment-credit/view/RecruitmentCredit'
import EditJobAd from './pages/recruitment-create-job-ad/view/EditJobAd'
import PaymentSuccessful from './pages/recruitment-payment/components/PaymentSuccessful'
import PublishDrafJobAds from './pages/recruitment-create-job-ad/view/PublishDrafJobAds'
import PaymentStatusCandidatePurchase from './pages/recruitment-payment/components/PaymentStatusCandidatePurchase'
import { useTheme } from '@mui/system'
import { useMediaQuery } from '@mui/material'
import MobileCover from './pages/recruitment-mobile/view/MobileCover'
import InterviewScheduler from './pages/recruitment-interview-scheduler/view/InterviewScheduler'
import ExternalTalent from './pages/recruitment-external-talent/view/ExternalTalent'
import ViewTalentDrawer from './pages/recruitment-external-talent/components/ViewTalentDrawer'
import RedundantTalent from './pages/recruitment-external-talent/view/RedundantTalent'
import EmailSpecificView from './pages/recruitment-external-talent/view/EmailSpecificView'
import RecruiterCalendar from './pages/recruitment-talent-calendar/view/TalentCalendar'

const RecruitmentRoutes = () => {
  const location = useLocation()
  const state = location.state

  return (
    <Routes location={state?.backgroundLocation || location}>
      <Route index element={<Navigate to="applicant-tracking" />} />
      <Route path="applicant-tracking" element={<RecruitmentDashboard />} />
      <Route path="applicant-tracking/job-ad" element={<CreateJobAd />} />
      <Route path="applicant-tracking/job-ads/:id/manage-applicant" element={<ManageApplicant />} />
      <Route path="applicant-tracking/job-ads/:id/edit" element={<EditJobAd />} />
      <Route path="applicant-tracking/job-ads/:id/draft" element={<PublishDrafJobAds />} />
      <Route path="cart" element={<RecruitmentCart />} />
      <Route path="cart/payment" element={<RecruitmentPayment />} />
      <Route path="payment/success" element={<PaymentSuccessful />} />
      <Route path="payment/fail" element={<PaymentSuccessful isSuccess={false} />} />
      <Route
        path="payment/candidate-purchased/success"
        element={<PaymentStatusCandidatePurchase />}
      />
      <Route
        path="payment/candidate-purchased/fail"
        element={<PaymentStatusCandidatePurchase isSuccess={false} />}
      />
      <Route path="credit/top-up" element={<RecruitmentTopUpCredit />} />
      <Route path="credit" element={<RecruitmentCredit />} />
      <Route path="schedule-interview" element={<InterviewScheduler />} />
      <Route path="schedule-interview/edit" element={<InterviewScheduler />} />
      <Route path="recruiter-calendar" element={<RecruiterCalendar />} />
      <Route path="external-talent" element={<ExternalTalent />} />
      <Route path="external-talent/:id/view-talent" element={<ViewTalentDrawer />} />
      <Route path="external-talent/redundant" element={<RedundantTalent />} />
      <Route path="external-talent/redundant/:id" element={<EmailSpecificView />} />
    </Routes>
  )
}

export default RecruitmentRoutes
